
import Vue from 'vue'

const locales = {keys(){return []}}
global['____A031928____'] = true;
delete global['____A031928____'];
global.__uniConfig = {"tabBar":{"color":"#7A7E83","selectedColor":"#1b88ee","backgroundColor":"#ffffff","borderStyle":"black","fontSize":"12px","list":[{"pagePath":"pages/quant/index","text":"量化","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/indexInfo/Index","text":"市场","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/HomePage","text":"转债","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/UserInfo/Index","text":"我的","iconPath":"","selectedIconPath":"","redDot":false,"badge":""}]},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"uni-app11","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"},"easycom":{"custom":{"number":"@/components/Number.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"^u-(.*)":"@/uni_modules/uview-ui/components/u-$1/u-$1.vue"}};
global.__uniConfig.compilerVersion = '4.23';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__A031928';
global.__uniConfig.appName = '阿牛数据';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-quant-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/pages/quant/index"+'.vue')), 'pages-quant-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-stock-quant-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/pages/stock-quant/index"+'.vue')), 'pages-stock-quant-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-fund-Index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/pages/fund/Index"+'.vue')), 'pages-fund-Index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-indexInfo-Index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/pages/indexInfo/Index"+'.vue')), 'pages-indexInfo-Index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-HomePage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/pages/HomePage"+'.vue')), 'pages-HomePage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-UserInfo-Index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/pages/UserInfo/Index"+'.vue')), 'pages-UserInfo-Index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-redirect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/redirect"+'.vue')), 'subpages-redirect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-detail-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/detail/detail"+'.vue')), 'subpages-detail-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-detail-userSelect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/detail/userSelect"+'.vue')), 'subpages-detail-userSelect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-detail-userInfoEdit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/detail/userInfoEdit"+'.vue')), 'subpages-detail-userInfoEdit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-bondDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/bondDetail"+'.vue')), 'subpages-bondDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-stockDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/stockDetail"+'.vue')), 'subpages-stockDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-holderDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/holderDetail"+'.vue')), 'subpages-holderDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-fund-qdiiDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/fund/qdiiDetail"+'.vue')), 'subpages-fund-qdiiDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-bond-BondTop', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/bond/BondTop"+'.vue')), 'subpages-bond-BondTop'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-bond-BondTopDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/bond/BondTopDetail"+'.vue')), 'subpages-bond-BondTopDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-fund-fundDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/fund/fundDetail"+'.vue')), 'subpages-fund-fundDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-fund-lofDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/fund/lofDetail"+'.vue')), 'subpages-fund-lofDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-payment-sellPage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/payment/sellPage"+'.vue')), 'subpages-payment-sellPage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-payment-sellPageById', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/payment/sellPageById"+'.vue')), 'subpages-payment-sellPageById'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-payment-distributer', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/payment/distributer"+'.vue')), 'subpages-payment-distributer'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-payment-paymentSuccess', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/payment/paymentSuccess"+'.vue')), 'subpages-payment-paymentSuccess'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/order"+'.vue')), 'subpages-order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-notify', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/notify"+'.vue')), 'subpages-notify'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-fund-indexFundDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/fund/indexFundDetail"+'.vue')), 'subpages-fund-indexFundDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-pdfView', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/pdfView"+'.vue')), 'subpages-pdfView'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-backTest-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/backTest/index"+'.vue')), 'subpages-backTest-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-backTest-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/backTest/detail"+'.vue')), 'subpages-backTest-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-backTest-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/backTest/list"+'.vue')), 'subpages-backTest-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-securities-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/securities/detail"+'.vue')), 'subpages-securities-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-fund-SearchFundList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/fund/SearchFundList"+'.vue')), 'subpages-fund-SearchFundList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-fund-marketIndexDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/fund/marketIndexDetail"+'.vue')), 'subpages-fund-marketIndexDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-quant-create', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/quant/create"+'.vue')), 'subpages-quant-create'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-quant-create-strategy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/quant/create-strategy"+'.vue')), 'subpages-quant-create-strategy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-stock-quant-create', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/stock-quant/create"+'.vue')), 'subpages-stock-quant-create'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-stock-quant-create-strategy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/stock-quant/create-strategy"+'.vue')), 'subpages-stock-quant-create-strategy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-etf-quant-create', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/etf-quant/create"+'.vue')), 'subpages-etf-quant-create'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-etf-quant-create-strategy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/etf-quant/create-strategy"+'.vue')), 'subpages-etf-quant-create-strategy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subpages-portfolio-rotation-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/workspace/src/subpages/portfolio-rotation-detail"+'.vue')), 'subpages-portfolio-rotation-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/quant/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"量化回测","enablePullDownRefresh":true})
      },
      [
        createElement('pages-quant-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-quant-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/quant/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:44
}
},
{
path: '/pages/stock-quant/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"股票量化回测","enablePullDownRefresh":true})
      },
      [
        createElement('pages-stock-quant-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-stock-quant-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/stock-quant/index',
  windowTop:44
}
},
{
path: '/pages/fund/Index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('pages-fund-Index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-fund-Index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/fund/Index',
  windowTop:44
}
},
{
path: '/pages/indexInfo/Index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('pages-indexInfo-Index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-indexInfo-Index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/indexInfo/Index',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:44
}
},
{
path: '/pages/HomePage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据"})
      },
      [
        createElement('pages-HomePage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-HomePage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/HomePage',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/UserInfo/Index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据"})
      },
      [
        createElement('pages-UserInfo-Index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-UserInfo-Index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/UserInfo/Index',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:44
}
},
{
path: '/subpages/redirect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据"})
      },
      [
        createElement('subpages-redirect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-redirect',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/redirect',
  windowTop:44
}
},
{
path: '/subpages/detail/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"概念详情"})
      },
      [
        createElement('subpages-detail-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-detail-detail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/detail/detail',
  windowTop:44
}
},
{
path: '/subpages/detail/userSelect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的自选"})
      },
      [
        createElement('subpages-detail-userSelect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-detail-userSelect',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/detail/userSelect',
  windowTop:44
}
},
{
path: '/subpages/detail/userInfoEdit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户信息编辑"})
      },
      [
        createElement('subpages-detail-userInfoEdit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-detail-userInfoEdit',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/detail/userInfoEdit',
  windowTop:44
}
},
{
path: '/subpages/bondDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"债转详情","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-bondDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-bondDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/bondDetail',
  windowTop:44
}
},
{
path: '/subpages/stockDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"正股详情","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-stockDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-stockDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/stockDetail',
  windowTop:44
}
},
{
path: '/subpages/holderDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"十大持有人详情","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-holderDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-holderDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/holderDetail',
  windowTop:44
}
},
{
path: '/subpages/fund/qdiiDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-fund-qdiiDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-fund-qdiiDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/fund/qdiiDetail',
  windowTop:44
}
},
{
path: '/subpages/bond/BondTop',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-bond-BondTop', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-bond-BondTop',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/bond/BondTop',
  windowTop:44
}
},
{
path: '/subpages/bond/BondTopDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-bond-BondTopDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-bond-BondTopDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/bond/BondTopDetail',
  windowTop:44
}
},
{
path: '/subpages/fund/fundDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-fund-fundDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-fund-fundDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/fund/fundDetail',
  windowTop:44
}
},
{
path: '/subpages/fund/lofDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-fund-lofDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-fund-lofDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/fund/lofDetail',
  windowTop:44
}
},
{
path: '/subpages/payment/sellPage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-payment-sellPage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-payment-sellPage',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/payment/sellPage',
  windowTop:44
}
},
{
path: '/subpages/payment/sellPageById',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-payment-sellPageById', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-payment-sellPageById',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/payment/sellPageById',
  windowTop:44
}
},
{
path: '/subpages/payment/distributer',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-payment-distributer', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-payment-distributer',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/payment/distributer',
  windowTop:44
}
},
{
path: '/subpages/payment/paymentSuccess',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付成功","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-payment-paymentSuccess', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-payment-paymentSuccess',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/payment/paymentSuccess',
  windowTop:44
}
},
{
path: '/subpages/order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-order',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/order',
  windowTop:44
}
},
{
path: '/subpages/notify',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-notify', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-notify',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/notify',
  windowTop:44
}
},
{
path: '/subpages/fund/indexFundDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"阿牛数据","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-fund-indexFundDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-fund-indexFundDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/fund/indexFundDetail',
  windowTop:44
}
},
{
path: '/subpages/pdfView',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预览","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-pdfView', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-pdfView',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/pdfView',
  windowTop:44
}
},
{
path: '/subpages/backTest/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"回测","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-backTest-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-backTest-index',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/backTest/index',
  windowTop:44
}
},
{
path: '/subpages/backTest/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"回测详情","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-backTest-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-backTest-detail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/backTest/detail',
  windowTop:44
}
},
{
path: '/subpages/backTest/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"回测列表","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-backTest-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-backTest-list',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/backTest/list',
  windowTop:44
}
},
{
path: '/subpages/securities/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"证券","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-securities-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-securities-detail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/securities/detail',
  windowTop:44
}
},
{
path: '/subpages/fund/SearchFundList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"基金搜索","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-fund-SearchFundList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-fund-SearchFundList',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/fund/SearchFundList',
  windowTop:44
}
},
{
path: '/subpages/fund/marketIndexDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"基金详情","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-fund-marketIndexDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-fund-marketIndexDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/fund/marketIndexDetail',
  windowTop:44
}
},
{
path: '/subpages/quant/create',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑回测","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-quant-create', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-quant-create',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/quant/create',
  windowTop:44
}
},
{
path: '/subpages/quant/create-strategy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑策略","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-quant-create-strategy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-quant-create-strategy',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/quant/create-strategy',
  windowTop:44
}
},
{
path: '/subpages/stock-quant/create',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑回测","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-stock-quant-create', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-stock-quant-create',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/stock-quant/create',
  windowTop:44
}
},
{
path: '/subpages/stock-quant/create-strategy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑策略","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-stock-quant-create-strategy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-stock-quant-create-strategy',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/stock-quant/create-strategy',
  windowTop:44
}
},
{
path: '/subpages/etf-quant/create',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"ETF编辑回测","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-etf-quant-create', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-etf-quant-create',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/etf-quant/create',
  windowTop:44
}
},
{
path: '/subpages/etf-quant/create-strategy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"ETF编辑策略","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-etf-quant-create-strategy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-etf-quant-create-strategy',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/etf-quant/create-strategy',
  windowTop:44
}
},
{
path: '/subpages/portfolio-rotation-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"轮动记录","enablePullDownRefresh":false})
      },
      [
        createElement('subpages-portfolio-rotation-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subpages-portfolio-rotation-detail',
  isNVue:false,maxWidth:0,
  pagePath:'subpages/portfolio-rotation-detail',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
